import React, { useEffect, useState } from "react";
import CookiePreferencesModal from "./CookiePreferencesModal";
import "./CookieBanner.scss";

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie-preferences");
        if (!consent) setVisible(true);
    }, []);

    const acceptAll = () => {
        localStorage.setItem(
            "cookie-preferences",
            JSON.stringify({
                essential: true,
                analytics: true,
                functionality: true,
            })
        );
        setVisible(false);
    };

    const rejectNonEssential = () => {
        localStorage.setItem(
            "cookie-preferences",
            JSON.stringify({
                essential: true,
                analytics: false,
                functionality: false,
            })
        );
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <>
            <div className="cookie-banner">
                <p>
                    We use cookies to enhance your experience. Manage your preferences
                    anytime. Read our{" "}
                    <a href="/policies/privacy">Privacy Notice</a>.
                </p>

                <div className="actions">
                    <button onClick={rejectNonEssential} className="reject-btn">
                        Reject Non-Essential
                    </button>

                    <button onClick={() => setShowModal(true)} className="prefs-btn">
                        Cookie Preferences
                    </button>

                    <button onClick={acceptAll} className="accept-btn">
                        Accept All
                    </button>
                </div>
            </div>

            {showModal && (
                <CookiePreferencesModal onClose={() => setShowModal(false)} />
            )}
        </>
    );
};

export default CookieBanner;
